var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProgramControlPlayIcon = function SvgProgramControlPlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.754 5.386v13.333l11.692-6.666z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 12a12 12 0 1 0 24 0 12 12 0 1 0-24 0m2 0a10 10 0 1 0 20 0 10 10 0 1 0-20 0"
  })));
};
export default SvgProgramControlPlayIcon;